import React from 'react';
import { G, Path } from 'react-native-svg';

import { IconDef } from './types';

export const Close: IconDef = {
  svg: (
    <G>
      <Path
        d="M18 6L6 18M6 6L18 18"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </G>
  ),
  svgStyles(color) {
    return {
      stroke: color,
      strokeWidth: 2,
    };
  },
};
